export default __webpack_public_path__ + "static/media/OPD_CARD_HOSPITAL_1.394c65fb.png";